module.exports = __webpack_public_path__ + "static/media/zen.07ecb441.svg";